export default {
  FETCHED_ALL: 'FETCHED_ALL_PERMISSIONS',
};
